<iframe class="video" width="560" height="315" [src]='link' allow="autoplay" frameborder="0" allowfullscreen></iframe>
